import { Globe, MapPin, Phone } from "lucide-react";
import { BUSINESS, WA_MESSAGES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const QUICK_LINKS = [
  { label: "Services", href: "#services", testId: "footer-link-services" },
  { label: "About", href: "#about", testId: "footer-link-about" },
  { label: "Location", href: "#location", testId: "footer-link-location" },
  { label: "FAQs", href: "#faq", testId: "footer-link-faq" },
];

const Footer = () => (
  <footer className="bg-[#141210] pb-28 pt-14 text-stone-400 md:pb-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={BUSINESS.logo}
              alt="GK Wellness & Luxury Spa logo"
              loading="lazy"
              decoding="async"
              className="h-12 w-12 rounded-full object-cover ring-1 ring-[#C5A059]/40"
              width="48"
              height="48"
            />
            <span className="leading-tight">
              <span className="block font-serif text-xl font-semibold text-white">GK Wellness</span>
              <span className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-[#C5A059]">
                &amp; Luxury Spa
              </span>
            </span>
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.3em] text-stone-500">
            {BUSINESS.tagline}
          </p>
          <div className="mt-6">
            <WhatsAppButton
              message={WA_MESSAGES.general}
              label="WhatsApp Us"
              testId="footer-whatsapp-link"
              size="sm"
            />
          </div>
        </div>

        <nav aria-label="Footer">
          <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white">
            Quick Links
          </h3>
          <ul className="mt-4 space-y-3">
            {QUICK_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  data-testid={link.testId}
                  className="text-sm transition-colors hover:text-[#EED8A1] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white">Contact</h3>
          <address className="mt-4 space-y-3 text-sm not-italic">
            <p className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#C5A059]" aria-hidden="true" />
              <span>{BUSINESS.address}</span>
            </p>
            <p className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 shrink-0 text-[#C5A059]" aria-hidden="true" />
              <a
                href={BUSINESS.tel}
                data-testid="footer-phone-link"
                className="transition-colors hover:text-[#EED8A1]"
              >
                {BUSINESS.phoneDisplay}
              </a>
            </p>
            <p className="flex items-center gap-2.5">
              <Globe className="h-4 w-4 shrink-0 text-[#C5A059]" aria-hidden="true" />
              <a
                href={BUSINESS.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website-link"
                className="transition-colors hover:text-[#EED8A1]"
              >
                {BUSINESS.website}
              </a>
            </p>
          </address>
        </div>
      </div>

      <div className="mt-12 border-t border-stone-800 pt-6 text-center text-xs text-stone-500">
        © 2026 GK Wellness &amp; Luxury Spa. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
